import { HollowDotsSpinner } from "react-epic-spinners";
import { useSelector } from "react-redux";
import { Punonjësit } from "../../../assets/icons";
import DragCard from "./Draggable/DragCard";
import { useNavigate } from "react-router-dom";

const TotalEmployeeNumber = () => {
  const navigate = useNavigate();
  // get active employes from redoux
  const { activeEmployees } = useSelector((state) => state.employeesList);
  const { isDarkMode } = useSelector((state) => state.usersList);
  //Eshte shtuar kushtu me poshte sepse kur nuk ka punonjes nuk del 0
  const data = {
    icon: <Punonjësit fill={isDarkMode ? "#e6e6e6" : "#1d3943"} />,
    // icon: <IconPunonjesit />,
    text: "Totali i punonjësve",
    number: activeEmployees?.length ? activeEmployees?.length : 0,
  };

  /**
   * * @EneaXharau - Added independent loading functionality, visual loader based on validation below
   */
  return (
    <div style={{ width: "100%", height: "100%" }}>
      {!!activeEmployees ? (
        <DragCard data={data} onClick={() => navigate("/punonjesit")} />
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <HollowDotsSpinner color="#1da193" size={24} />
        </div>
      )}
    </div>
  );
};
// 2h 15
// 5h 45

export default TotalEmployeeNumber;
